import { useState, useEffect } from 'react';
import { Container, Button, Typography, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import 'react-toastify/dist/ReactToastify.css';
import AddIcon from '@mui/icons-material/Add';
// import CategoryCard from '../../component/StyledComponents/CreateCards';
import CreateIcon from '../../forms/CreateIcon';
import type { Icons } from '../../../types/icons';
import { getAllICon } from '../../../services/api/OttIcon';
import IconCard from '../../component/StyledComponents/CreateCards';

const IconComponent: React.FC = () => {
	const [categories, setCategories] = useState<Icons[]>();
	const [openForm, setOpenForm] = useState(false);
	const [selectedIcon, setSelectedIcon] = useState<Icons | null>(null);
	const [searchTerm, setSearchTerm] = useState('');
	const [loading, setLoading] = useState(true);
	const [iconsCount, setIconsCount] = useState(0);
	const fetchCategories = async () => {
		try {
			setLoading(true);
			const data = await getAllICon();
			if (data.success) {
				setCategories(data?.data.ottApps || []);
				setIconsCount(data?.data.count || 0);
				console.log(data?.data.ottApps, 'ott apps icons');
			}
		} catch (error) {
			console.log(error);
			// toast.error('Failed to fetch categories');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchCategories();
	}, []);

	const handleAddCategory = () => {
		setSelectedIcon(null);
		setOpenForm(true);
	};

	const handleEditCategory = (category: Icons) => {
		setSelectedIcon(category);
		setOpenForm(true);
	};

	const handleCloseForm = () => {
		setOpenForm(false);
		setSelectedIcon(null);
	};

	const filteredCategories = Array.isArray(categories)
		? categories.filter((category) =>
				category?.name?.toLowerCase().includes(searchTerm.toLowerCase())
			)
		: [];

	return (
		<>
			<Container>
				<Typography
					gutterBottom
					style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '24px' }}
					color="secondary"
				>
					OTT Images({iconsCount ? iconsCount : 0})
				</Typography>
				<Typography
					className="d-flex"
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						flexDirection: { xs: 'column', sm: 'row', md: 'row' },
						marginBottom: '10px',
					}}
				>
					<div>
						<Typography
							style={{
								fontFamily: 'Poppins',
								fontWeight: '400',
								fontSize: '16px',
								// color: '#006D48',
							}}
							color="secondary"
						>
							Manage your plans ott images, add new images, and more.
						</Typography>
					</div>
					<Typography
						sx={{
							width: {
								xs: '100%',
							},
							flexBasis: { xs: 'auto', sm: 'content', md: 'content' },
						}}
					>
						<Button
							sx={{
								width: {
									xs: '100%',
									sm: 'auto',
									md: 'auto',
								},
							}}
							variant="contained"
							color="primary"
							onClick={handleAddCategory}
							startIcon={<AddIcon />}
						>
							Add Icon
						</Button>
					</Typography>
				</Typography>

				<Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
					<Grid size={{ xs: 12, sm: 12, md: 12 }}>
						<TextField
							label="Search icon by name"
							variant="outlined"
							margin="none"
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
							size="small"
							fullWidth
						/>
					</Grid>
				</Grid>
				<Grid container spacing={3}>
					{loading
						? Array.from(new Array(8)).map((_, index) => (
								<Grid key={index} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
									<div
										style={{
											backgroundColor: '#ccc',
											height: '200px',
											borderRadius: '4px',
										}}
									/>
								</Grid>
							))
						: filteredCategories.map((category) => (
								<Grid key={category?._id} size={{ xs: 4, sm: 3, md: 2, lg: 2 }}>
									<IconCard
										iconData={category}
										onClick={handleEditCategory}
										// fetchCategories={fetchCategories}
									/>
								</Grid>
							))}
				</Grid>
				<CreateIcon
					open={openForm}
					handleClose={handleCloseForm}
					fetchCategories={fetchCategories}
					iconData={selectedIcon}
				/>
			</Container>
		</>
	);
};

export default IconComponent;
